<template>
    <div class="light-grey-bg">
    <v-container>
        <v-layout row wrap justify-center class="program">
            <v-flex xs12>
                <p class="small-title"><a @click="$router.push({name: 'programs'})">Programas</a></p>
            </v-flex>
            <v-flex xs12 class="program-title">
                <h1>Head Start</h1>
            </v-flex>
            <v-flex  md8>
                <v-card class="program-info" style="margin: 0 auto;">
                    <img class="program-image" src="/images/headstart.png" />
                    <v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 align-self-center align-center>
                                <div style="margin: 0 auto;">
                                    <table>
                                        <tr>
                                            <td><img src="/images/icons/day.png"/></td>
                                            <td>Duración del día</td>
                                            <td>Día completo</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/year.png"/></td>
                                            <td>Longitud del año</td>
                                            <td>Año escolar tradicional</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/car.png"/></td>
                                            <td>Transporte</td>
                                            <td>Varía</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/curriculum.png"/></td>
                                            <td>Plan de estudios</td>
                                            <td><img src="/images/icons/check.png"/></td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/cost.png"/></td>
                                            <td>Costo</td>
                                            <td>Gratis</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/location.png"/></td>
                                            <td>Ubicación</td>
                                            <td>Guarderia o Escuela</td>
                                        </tr>
                                    </table>
                                </div>
                            </v-flex>
                            <v-flex class="program-overview" xs12>
                                <div style="margin: 0 auto; background: #1b3675;color: white;">
                                    <h3>DESCRIPCCIÓN DEL PROGRAMA</h3>
                                    <p>
                                        Head Start es un programa federal que provee educación comprensiva de salud, nutrición, y servicios de compromiso entre la familia, padres, y comunidad para 
                                        familias y niños de temprana edad y bajo ingreso. Los programas de Head Start son administrado por centros educativos que no son federales en todo el estado.  
                                        Muchos programas de Head Start ofrecen dia de escuela tradicional.
                                    </p>
                                </div>
                            </v-flex>
                            <v-flex xs12>
                                    <v-carousel>
                                      <v-carousel-item
                                        v-for="(item,i) in items"
                                        :key="i"
                                        :src="item.src"
                                      ></v-carousel-item>
                                    </v-carousel>                               
                            </v-flex>
                            <v-flex xs12 style="text-align: left">
                                <h3>TRANSPORTE OFRECIDO</h3>
                                <p>
                                    Algunos centros ofrecen transporte gratis.
                                </p>
                            </v-flex>
                            <v-flex xs12 style="text-align: left">
                                <h3>PLAN DE ESTUDIOS</h3>
                                <p>
                                    El plan de estudios instructivo incluye Creative Curriculum por Teaching Strategies Gold® y Conscious Discipline®
                                </p>
                            </v-flex>
                            <v-flex xs12 style="text-align: left">
                                <h3>COSTO</h3>
                                <p>
                                    Gratis
                                </p>
                            </v-flex>
                            <v-flex xs12 style="text-align: left">
                                <h3>ELEGIBILIDAD PARA SERVICIOS</h3>
                                <p>
                                    Niños tienen que tener 3 ó 4 años y estar bajo 100% de pobreza. Programas locales ofrecen prioridad a niños con discapacidades, niños bajo custodia 
                                    temporaria, niños sin hogares, y familias en emergencia. Por favor averigue con su programa local de Head Start los requirimientos y eligibilidad. 
                                    Para mas información, llame a la oficina de Colaboración de Head Start a  
                                    <a href="tel:803-898-2550">803-898-2550</a> ó visite <a target="_blank" href="https://sc-headstart.org">sc-headstart.org</a> ó <a target="_blank" href="https://scacap.org">scacap.org</a>.
                                </p>
                                <v-btn round large=true color="primary" @click="$router.push({name: 'eligibility'})"><span class="btn-white">VERIFICAR ELEGIBILIDAD</span></v-btn>
                                <hr>
                            </v-flex>
                        </v-layout>        
                    </v-card-title>
                    <v-card-actions>
                        <v-btn flat color="primary" @click="$router.push({name: 'programs'})">&lt; VOLVER A LOS PROGRAMAS</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex md4>
                <v-layout row wrap>
                    <v-flex class="" xs12>
                        <v-card class="contact-sidebar" color="primary" style="color: white;text-align:left;">
                            <v-card-title>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <h2>Contacto</h2>
                                            <p class="bold">1535 Confederate Ave.<br/>
                                            Columbia, SC 29202</p>
                                            
                                            <p>Teléfono: <a href="tel:803-898-2550">803-898-2550</a><br/>
                                            Número de Fax: 803-898-4458</p>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>
                        </v-card>
                    </v-flex>
                    <v-flex xs12>
                        <v-card class="quote-sidebar" color="lightblue" style="color: white; display:none">
                            <v-card-title>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <img src="/images/icons/quote-icon.png"/>
                                        <p>
                                            “First Steps ha hecho un mundo de diferencia. Fue un gran alivio ser ayudado tan rápido.”
                                        </p>
                                        <br/>
                                        <span>- Betty W., Abuela de un niño inscrito en un aula de First Steps 4K</span>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
    <div class="grey-bg">
        <v-container>  
        <v-card>
            <v-card-title class="cta-card">
                <v-layout row wrap justify-center align-center>
                    <v-flex xs12 sm4 class="red-section">
                        <img alt="" src="/images/icons/icon.png"/>
                    </v-flex>
                    <v-flex xs12 sm8 class="cta-card-text">
                        <v-layout row wrap justify-center align-center>
                            <v-flex xs10>
                                <div class="red-section-content">
                                    <h2>¡ENCUENTRE OPCIONES DE PRE-K CERCA DE TI!</h2>
                                    <p>Encuentre las escuelas preescolares que ofrecen programas para los cuales su hijo es elegible. Simplemente ingrese su dirección para encontrar un centro ubicado cerca de usted.</p>
                                </div>
                            </v-flex>
                            <v-flex xs2 class="arrow-img">
                                <a href="/provider-search"><img alt="Provider Search" src="/images/icons/arrow.png"/></a>
                            </v-flex>
                        </v-layout>  
                    </v-flex>
                </v-layout>
            </v-card-title>
        </v-card>
        </v-container>
    </div>
    </div>
    
</template>
<style scoped>
    .program{
        margin: 0 auto;
        text-align: center;
    }
    .red-section{
        background: #e94342;
        text-align: center;
    }

    .cta-card{
        padding: 0;    
    }

    .cta-card-text{
        padding: 15px 15px;
    }
</style>

<script>
     export default {
    data () {
      return {
        items: [
          {
            src: '/images/slides/iStock-475743819-2-440x293.jpg'
          },
          {
            src: '/images/slides/kids-playing-playground.jpg'
          },
          {
            src: '/images/slides/two-women-measuring-a-girl.jpg'
          },
          {
            src: '/images/slides/woman-playing-at-playground-with-two-children.jpg'
          }
        ]
      }
    }
  }
</script>